import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

const MODULE_CARDS = [
  { module: 'abattage',    icon: '📝', titre: "Saisie d'abattage",       desc: 'Module 1 — Production quotidienne',        route: '/saisies',          color: '#2E7D32' },
  { module: 'facturation', icon: '🧾', titre: 'Facturation',             desc: 'Module 2 — Facturation journalière',       route: '/facturation/liste', color: '#1565C0' },
  { module: 'rapports',    icon: '📊', titre: 'Rapports',                desc: 'Statistiques multi-abattoirs',             route: '/rapports',          color: '#6A1B9A' },
  { module: 'caisse',      icon: '💰', titre: 'Caisses',                 desc: 'Module 3 — Gestion des caisses',           route: '/caisses',           color: '#E65100' },
  { module: 'achats',      icon: '🛒', titre: 'Achats & Décaissements',  desc: 'Dossiers achat, travaux, fournisseurs',    route: '/achats',            color: '#1B5E20' },
  { module: 'comite',      icon: '📋', titre: 'Comité de Dépouillement', desc: 'Analyse des offres fournisseurs',          route: '/comite',            color: '#00695C' },
  { module: 'utilisateurs',icon: '👥', titre: 'Utilisateurs',            desc: 'Gestion des comptes et rôles',             route: '/users',             color: '#B71C1C' },
  { module: 'parametres',  icon: '⚙️', titre: 'Paramètres',              desc: 'Tarifs, configuration abattoirs',          route: '/parametres',        color: '#546E7A' },
];

const CARTE_ROLES = { icon: '🔐', titre: 'Rôles & Permissions', desc: 'Gestion des rôles et accès', route: '/roles', color: '#4A148C' };

const C = { primary:'#2E7D32', primaryDark:'#1B5E20', border:'#E0E0E0', light:'#F4F6F9', textDark:'#212121', textMid:'#616161', textLight:'#9E9E9E' };

export default function Dashboard() {
  const { utilisateur, logout } = useAuth();
  const navigate = useNavigate();
  const { peut, loading } = usePermissions();
  const monRole = utilisateur?.role || '';
  const estAdmin = ['super_admin', 'admin'].includes(monRole);

  const modulesVisibles = [
    ...MODULE_CARDS.filter(card => peut(card.module, 'lire')),
    ...(estAdmin ? [CARTE_ROLES] : []),
  ];

  return (
    <div style={{ minHeight: '100vh', background: C.light, display: 'flex', flexDirection: 'column' }}>
      {/* Navbar Dashboard */}
      <div style={{ background: C.primary, padding: '10px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <img src="/logo-sogas.png" alt="SOGAS" style={{ height: 44, objectFit: 'contain' }} />
          <div style={{ color: 'white' }}>
            <div style={{ fontWeight: 700, fontSize: 15, letterSpacing: '0.5px' }}>SOGAS V2</div>
            <div style={{ fontSize: 11, opacity: 0.8 }}>Tableau de bord</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>
            {utilisateur?.prenom} {utilisateur?.nom}
          </span>
          <button onClick={() => navigate('/changer-mot-de-passe')}
            style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.35)', color: 'white', padding: '7px 14px', borderRadius: 7, cursor: 'pointer', fontSize: 12 }}>
            🔒 Mot de passe
          </button>
          <button onClick={() => { logout(); navigate('/login'); }}
            style={{ background: '#C62828', border: 'none', color: 'white', padding: '7px 16px', borderRadius: 7, cursor: 'pointer', fontWeight: 700, fontSize: 12 }}>
            Déconnexion
          </button>
        </div>
      </div>

      {/* Contenu */}
      <div style={{ flex: 1, padding: '36px 40px' }}>
        <h2 style={{ color: C.primaryDark, marginBottom: 6, fontSize: 24, fontWeight: 700 }}>Tableau de bord SOGAS</h2>
        <p style={{ color: C.textMid, marginBottom: 32, fontSize: 14 }}>
          Bienvenue{utilisateur ? `, ${utilisateur.prenom}` : ''} ! Choisissez un module pour commencer.
        </p>

        {loading ? (
          <div style={{ color: C.textLight, fontSize: 14, fontStyle: 'italic' }}>Chargement des modules...</div>
        ) : (
          <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
            {modulesVisibles.map(m => (
              <div
                key={m.route}
                style={{ background: '#fff', borderRadius: 14, padding: '24px 22px', width: 210, border: `0.5px solid ${C.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', borderTop: `4px solid ${m.color}`, cursor: 'pointer', transition: 'transform 0.15s, box-shadow 0.15s' }}
                onClick={() => navigate(m.route)}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; }}
              >
                <div style={{ fontSize: 36, marginBottom: 12 }}>{m.icon}</div>
                <div style={{ fontWeight: 700, fontSize: 14, color: m.color, marginBottom: 6 }}>{m.titre}</div>
                <div style={{ color: C.textLight, fontSize: 12 }}>{m.desc}</div>
              </div>
            ))}
            {modulesVisibles.length === 0 && (
              <div style={{ color: C.textLight, fontStyle: 'italic', fontSize: 14 }}>
                Aucun module accessible. Contactez l'administrateur.
              </div>
            )}
          </div>
        )}
      </div>

      {/* Footer */}
      <div style={{ textAlign: 'center', padding: '16px 20px', color: C.textLight, fontSize: 12, borderTop: `1px solid ${C.border}` }}>
        © 2026 SOGAS — Développé par <strong>Abdoul Aziz Talla</strong>
      </div>
    </div>
  );
}
